<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Edit {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Edit</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <loading :active="isLoading" :is-full-page="false"></loading>
            <form>
              <input type="hidden" name="emp_id" v-model="data.emp_id">
              <input type="hidden" name="year"  v-model="data.year">
              <input type="text" :value="data.emp_name" class="form-control" disabled>
              <table class="table">
                <thead>
                  <th>Januari</th>
                  <th>Februari</th>
                  <th>Maret</th>
                  <th>April</th>
                  <th>Mei</th>
                  <th>Juni</th>
                </thead>
                <tbody>
                  <td>
                    <money name="1" class="form-control form-control-sm" v-model="data.target[1]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="2" class="form-control form-control-sm" v-model="data.target[2]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="3" class="form-control form-control-sm" v-model="data.target[3]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="4" class="form-control form-control-sm" v-model="data.target[4]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="5" class="form-control form-control-sm" v-model="data.target[5]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="6" class="form-control form-control-sm" v-model="data.target[6]" v-bind="money"
                      required="required"></money>
                  </td>
                </tbody>
              </table>
              <table class="table">
                <thead>
                  <th>Juli</th>
                  <th>Agustus</th>
                  <th>September</th>
                  <th>Oktober</th>
                  <th>November</th>
                  <th>Desember</th>
                </thead>
                <tbody>
                  <td>
                    <money name="7" class="form-control form-control-sm" v-model="data.target[7]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="86" class="form-control form-control-sm" v-model="data.target[8]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="9" class="form-control form-control-sm" v-model="data.target[9]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="10" class="form-control form-control-sm" v-model="data.target[10]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="11" class="form-control form-control-sm" v-model="data.target[11]" v-bind="money"
                      required="required"></money>
                  </td>
                  <td>
                    <money name="12" class="form-control form-control-sm" v-model="data.target[12]" v-bind="money"
                      required="required"></money>
                  </td>
                </tbody>
              </table>

              <div class="btn-group">
                <button type="button" class="btn btn-primary save-form" @click="SaveForm()">Simpan</button>
                <router-link class="btn btn-warning" :to="{ name: table_module }">Kembali</router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from "v-money";
export default {
  data() {
    return {
      module: "Target",
      table_module: "target",
      alias_table: "target",
      data: {},
      uuid: this.$route.params.uuid,
      year: this.$route.params.year,
      money: {
        thousands: '.',
        prefix: 'Rp ',
        precision: 0,
      },
      isLoading: false
    };
  },
  components: {
    Money
  },
  mounted() {
    var year = this.year;
    console.log(year)
    this.axios
      .get("/" + this.table_module + "/edit/" + this.year + "/" + this.uuid)
      .then(response => {
        this.data = response.data.data;
        this.data.year = this.year
        console.log(this.data)
      })
      .catch(error => {
        if (error.response) {
          this.$router.push({ name: this.table_module });
        } else if (error.request) {
          console.log("Error", error.message);
        } else {
          console.log("Error", error.message);
        }
      });
  },
  methods: {
    SaveForm() {
      this.isLoading = true;
      this.axios
        .post("/target/update/" + this.uuid, this.data)
        .then((response) => {
          console.log(response)
          if (response.data.status == 200) {
            this.isLoading = false;
          }
        });
    },
  }
};
</script>